import React from 'react';
import moment from 'moment';
import jQuery from 'jquery';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
const common = require('../common/common');
const multibrand = require('../common/multibrand');
const env = require("../../config.js").default;

window.jQuery = jQuery;
try {
  require("bootstrap-datepicker/js/locales/bootstrap-datepicker."+ common.getLanguageDatePicker() +".js");
  require ('select2/dist/js/i18n/'+ common.getLanguage(false) +'.js');
  require("moment/locale/" + common.getLanguageMoment() + ".js");
} catch (err) {
  require("moment/locale/en-gb.js");
  require ('select2/dist/js/i18n/en.js');
  require("bootstrap-datepicker/js/locales/bootstrap-datepicker.en-GB.js");
}

class FilterDate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.state.folder = this.props.folder;
        this.state.pathname = this.props.pathname;
        this.state.pathnameBackend = this.props.pathnameBackend;
        this.state.selectedMonth = null;
        this.state.selectedYear = null;
    }

    
    componentDidMount() {
        const $ = window.$;
        $(window).resize(function () {
            $('.select2').css('width', "100%");
        });

        const years = (back) => {
            const year = new Date().getFullYear();
            return Array.from({ length: back }, (v, i) => year - back + i + 1);
        }

        $("#yearSelect").select2({
            placeholder: common.getTrad("Seleziona un anno"),
            language: common.getLanguage(),
            allowClear: true,
            width: '100%',
            dropdownAutoWidth: true,
            data: years(6)
        });


        $("#monthSelect").select2({
            placeholder: common.getTrad("Seleziona un mese"),
            language: common.getLanguage(),
            allowClear: true,
            width: '100%',
            dropdownAutoWidth: true,
            data: moment.localeData(common.getLanguage()).months()
        });
        this.updateIndexedDB()
    }

    changeFilterHandler = () => {
        const $ = window.$;
        //common.add_UX_data(this.state.folder, "Filters", "Type_filter", this.state.actualType);
        var selectedDates = {
            'month': this.state.selectedMonth,
            'year' : this.state.selectedYear 
        }
        this.props.sendData(selectedDates);
    }
    
    updateIndexedDB(){
        //imposta il primo valore se l'indexedDB è popolato
        const $ = window.$;
        common.get_UX_component(this.state.folder, "Filters", "Date_filter").then((dates) => {
        if (dates !== undefined && dates !== null && dates !== '') {
            $('#dateDot').css('visibility', 'visible')
            this.setState({selectedMonth: dates['month'], selectedYear : dates['year']}, () => {
            this.changeFilterHandler();
            window.setTimeout(() => {
                $('#monthSelect').val(moment(dates['month'], 'M' ).format("MMMM")).trigger("change");
                $('#yearSelect').val(dates['year']).trigger("change");
            }, 400);
            });
        }
        })
    }

    componentDidUpdate(){
        const $ = window.$;
        if (window.cc.ticketFirebird) {
            $('.select2').css('width', "100%");

            $('#yearSelect').on("select2:select", (e) => {
                var selectedType = e.params.data.id;
                this.state.selectedYear = selectedType
                this.changeFilterHandler();
            });
            $('#yearSelect').on('select2:unselect', (e) => {
                this.state.selectedYear = null
                this.changeFilterHandler();
            })

            $('#yearSelect').on('select2:select keyup select2:unselect', function () {
                if ($('#yearSelect').val() !== "") {
                    $('#dateDot').css('visibility', 'visible')
                } else {
                    $('#dateDot').css('visibility', 'hidden')
                }
            })

            $('#monthSelect').on("select2:select", (e) => {
                var selectedType = e.params.data.id;
                this.state.selectedMonth = moment().month(selectedType).format("M")
                this.changeFilterHandler();
            });
            $('#monthSelect').on('select2:unselect', (e) => {
                this.state.selectedMonth = null
                this.changeFilterHandler();
            })

            $('#monthSelect').on('select2:select keyup select2:unselect', function () {
                if ($('#monthSelect').val() !== "") {
                    $('#dateDot').css('visibility', 'visible')
                } else {
                    $('#dateDot').css('visibility', 'hidden')
                }
            })
        }
    }



    render(props){
        return(
            <div className={(this.props.customClass !== undefined ? this.props.customClass : "col-xl-6 col-lg-6") +  " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_language">
                <div className="col-12 p-0">
                    <p>{common.getTrad("Filtra per mese e anno")}<span> </span><span id="dateDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px' }}></span></p>
                    <div className="form-group input-daterange" id="meseAnno">
                        <div className="form-group anno col-md-6 pl-0">
                            <select style={{ 'textAlign': 'left' }} type="text" className="form-control" id="yearSelect" name="yearSelect" defaultValue={this.state.selectedYear}>
                                <option></option>
                            </select>
                        </div>
                        <div className="form-group mese col-md-6 pr-0">
                            <select type="text" style={{ 'textAlign': 'left' }} className="form-control" id="monthSelect" name="monthSelect">
                                <option></option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FilterDate;